import { resolveCanonicalClinicianDisplayName } from "@/pages/shared/profileAddressedName.js";

function cleanCandidateText(value = "") {
  const text = String(value || "").trim();
  const normalized = text.toLowerCase();
  if (
    !text ||
    normalized === "[object object]" ||
    normalized === "object" ||
    normalized === "null" ||
    normalized === "undefined"
  ) {
    return "";
  }
  return text;
}

function firstText(...values) {
  for (const value of values) {
    const text = cleanCandidateText(value);
    if (text) return text;
  }
  return "";
}

function stripDoctorPrefix(value = "") {
  return cleanCandidateText(value)
    .replace(/^(dr\.?|doctor)\s+/i, "")
    .trim();
}

function canonicalDoctorName(candidate) {
  if (!candidate || typeof candidate !== "object") return "";
  return resolveCanonicalClinicianDisplayName(
    {
      ...candidate,
      salutation: cleanCandidateText(candidate?.salutation) || "Dr.",
    },
    "",
  );
}

export function formatPatientFacingDoctorName(rawName = "") {
  const cleaned = stripDoctorPrefix(rawName);
  if (!cleaned) return "Doctor";
  return resolveCanonicalClinicianDisplayName(
    { salutation: "Dr.", display_name: cleaned },
    "Doctor",
  );
}

export function resolvePatientFacingDoctorName(...candidates) {
  for (const candidate of candidates) {
    if (!candidate) continue;

    if (typeof candidate === "string") {
      const text = cleanCandidateText(candidate);
      if (text && text !== "Doctor") return formatPatientFacingDoctorName(text);
      continue;
    }

    const canonical = canonicalDoctorName(candidate);
    if (canonical) return canonical;

    const text = firstText(
      candidate?.doctorName,
      candidate?.doctor_name,
      candidate?.name,
      candidate?.display_name,
      candidate?.full_name,
      candidate?.doctor?.doctorName,
      candidate?.doctor?.name,
      candidate?.doctor?.display_name,
      candidate?.doctor?.full_name,
      [candidate?.first_name, candidate?.last_name].filter(Boolean).join(" ")
    );
    if (text && text !== "Doctor") return formatPatientFacingDoctorName(text);
  }

  return "Doctor";
}
